import { BrowserRouter } from "react-router-dom";

import { RouteFocus } from "../shared/accessibility";
import { AppErrorBoundary } from "./error-boundary";
import { AppProviders } from "./providers";
import { AppRouter } from "./router";

export function App() {
  return <AppErrorBoundary><BrowserRouter><AppProviders><RouteFocus /><AppRouter /></AppProviders></BrowserRouter></AppErrorBoundary>;
}

export default App;
